/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Reply_Mark_Done_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Mark reply as done" |
*
* @param {Notes_Reply_Mark_Done_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_reply_mark_done_aria_label = /** @type {((inputs?: Notes_Reply_Mark_Done_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Reply_Mark_Done_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer la reponse comme terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort als erledigt markieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna la risposta come completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметьте ответ как выполненный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar la respuesta como realizada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记为已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信を完了としてマークする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर को पूर्ण के रूप में चिह्नित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marque a resposta como concluída.")
	return /** @type {LocalizedString} */ ("Mark reply as done")
});